<template>
  <v-footer padless>
    <v-container>
      <v-row>
        <!-- Sección de contacto -->
        <v-col cols="12" md="4">
          <h3 class="text-uppercase font-weight-bold">Contacto</h3>
          <p>Av. Uruguay 466, Lima</p>
          <p>Tel: (+51) 917915824</p>
          <p>Email: informes@consultora-innova.com</p>
        </v-col>
        <!-- Sección de redes sociales -->
        <v-col cols="12" md="4">
          <h3 class="text-uppercase font-weight-bold">Síguenos</h3>
          <v-btn icon class="social-btn"><v-icon>mdi-facebook</v-icon></v-btn>
          <v-btn icon class="social-btn"><v-icon>mdi-instagram</v-icon></v-btn>
        </v-col>
        <!-- Sección de horario -->
        <v-col cols="12" md="4">
          <h3 class="text-uppercase font-weight-bold">Horario</h3>
          <p>Lunes a Viernes: 8:00 - 22:00</p>
        </v-col>
      </v-row>
      <v-divider class="my-2" />
      <!-- Copyright -->
      <v-row justify="center">
        <span>&copy; 2025 Consultora Innova </span>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {};
</script>

<style scoped>
.v-footer {
  background: linear-gradient(to bottom, #006a8e, #0099cc); /* Degradado azul */
  color: white;
  padding: 20px 0;
}

.v-footer .text-uppercase {
  letter-spacing: 1px;
}

.v-footer p {
  margin: 5px 0;
}

.v-btn.social-btn {
  color: white;
  margin-right: 10px;
}

.v-btn.social-btn:hover {
  color: #ffcc00; /* Cambio de color al pasar el ratón */
}

.v-footer span {
  color: white;
  font-size: 14px;
}
</style>
